import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import ModalHeader from '@common-components/headers/ModalHeader';

const ChangePlansModal = props => {

    const {
        modalHeaderProps,
        actions: {
            hideModal
        }
    } = props;

    const handleCloseModal = () => hideModal();

    return (
        <Fragment>
            <ModalHeader { ...{ ...modalHeaderProps, hideCloseIcon: true }} />
            <div className="grid-container">
                <div className="gi-modal__body" id={`${modalHeaderProps.modalId}_body`}>
                    <p>
                        <FormattedMessage id="further_action.modal.warning_msg"/>
                    </p>
                </div>
            </div>
            <div className="gi-modal__controls">
                <button onClick={handleCloseModal}
                    className="usa-button gi-button gi-button__primary">
                    <FormattedMessage id="dashboard.ok"/>
                </button>
            </div>
        </Fragment>
    );
};

export default ChangePlansModal;
